// Single source of truth for broadcast email merge tags. Both server
// (`apps/server/src/_platform/email/merge-tag-registry.ts`, which adds a
// `resolve` resolver) and web (`apps/web/src/components/broadcasts/MergeTag.ts`,
// the TipTap node) import from this file. Adding a new merge tag is one
// entry here; both sides pick it up via TypeScript.
export const MERGE_TAG_NAMES = ['first_name'];
export const MERGE_TAG_LABELS = {
    first_name: 'First name',
};
//# sourceMappingURL=merge-tags.js.map